import { render, staticRenderFns } from "./AreaChartDashboard.vue?vue&type=template&id=872cba30&lang=pug&"
import script from "./AreaChartDashboard.vue?vue&type=script&lang=js&"
export * from "./AreaChartDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports